import React from "react";

const LoadingComponent: React.FC = () => {
  return (
    <div className="flex w-full justify-center p-4">
      <div className="inline-block size-10 border-2 rounded-full animate-spin border-l-transparent border-custom-500"></div>
    </div>
  );
};

export default LoadingComponent;
